AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "User");

AoPS.Alcumus.Models.User = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;
	var AlcMTrialColl = AoPS.Alcumus.Models.TrialCollection;
	var AlcMProbStats = AoPS.Alcumus.Models.ProblemStats;
	var AlcMSubject = AoPS.Alcumus.Models.Subject;
	var AlcMClass = AoPS.Alcumus.Models.Class;
	var AlcMTopic = AoPS.Alcumus.Models.Topic;
	var AlcMAstat = AoPS.Alcumus.Models.Astat;
	var AlcMProblem = AoPS.Alcumus.Models.Problem;
	var AlcMTrial = AoPS.Alcumus.Models.Trial;
	// Optional
	var AlcMSettings = AoPS.Alcumus.Models.Settings;
	var AlcMLogEntry = AoPS.Alcumus.Models.LogEntry;
	var AlcMQuest = AoPS.Alcumus.Models.Quest;

	return AlcMBase.BaseModel.extend({
		model_type: "user",
		id_attribute: "user_id",
		update_interval_ms: 600000, // 10 minutes
		defaults: {
			username: "",
			all_friends_loaded: false, // RR
			loading_friends: false, // RR
			friends_exclude: false, // RR
			friends_show_profile: false, // RR
			user_id: 0,
			avatar_data: null, // [url, width, height]
			is_me: false,
			is_admin: false,
			is_friend: false,
			is_private: false,
			is_teacher: false,
			is_uninitialized: false,
			// RR friend_data : [],
			friends: [], //RR
			limited_access: false,
			score: 0,
			xp: 0,
			level: 0,
			xp_in_level: 0,
			xp_to_next: 0,
			xp_percent: 0,
			curr_correct_streak: 0,
			curr_incorrect_streak: 0,
			curr_day_streak: 0,
			max_correct_streak: 0,
			max_incorrect_streak: 0,
			max_day_streak: 0,
			topics_passed: 0,
			topics_mastered: 0,
			total_days: 0,
			total_quests: 0,
			total_achievements: 0,
			is_tutorial_active: 0,
			abandons_left_today: 0,
			displayed_solution_pending: false,
			displayed_solution_error: null,
		},
		/** Additional attributes:
			(A + means an optional dependency is required; only use it if you can be
			  sure that dependency will be loaded.)

			master: Master model owning this one; guaranteed to be set

			problem_stats: ProblemStats model with totals
			+settings: Settings model with user's settings
			current_problem: Problem model user is doing now
			focus_parent: Either a Subject or Class model that user's focus is in,
				or the user model itself if "All topics in all subjects" is the focus.
			focus_topic: Topic model with user's focus, or equal to the focus_parent
				value if an "All topics" focus is chosen.
			displayed_solution: A rarely used optional Trial model, whose trial ID is
				irrelevant and unused. If set, the problem page will be forced to show
				this Trial model as a solution, and the play button will unset this
				field.

			+logs: Collection of LogEntry models
			subjects: Collection of Subject models
			classes: Collection of Class models
			topics: Collection of Topic models
			astats: Collection of Astat models
			trials: Collection of Trial models
			+quests: Collection of Quest models
		*/

		// TODO: document show_problem event craziness

		initialize: function () {
			this.setLoader(
				new LoadUtils.LoadManager({
					loadHandler: this.loadUser,
					context: this,
				})
			);

			this.quests_loader = new LoadUtils.LoadManager({
				loadHandler: this.loadQuests,
				context: this,
			});

			this.set("problem_stats", new AlcMProbStats());
			AlcMSettings && this.set("settings", new AlcMSettings({user: this}));

			this.set("current_problem", new AlcMProblem({user: this}));

			this.set("subjects", new AlcMBase.BaseCollection());
			this.get("subjects").setCreateFunction(
				_.bind(function (id) {
					return new AlcMSubject({id: id, user: this});
				}, this)
			);

			if (this.get("master").get("subject_order")) {
				this.setSubjectOrder(this.get("master").get("subject_order"));
			}
			this.listenTo(
				this.get("master"),
				"change:subject_order",
				_.bind(function () {
					this.setSubjectOrder(this.get("master").get("subject_order"));
				}, this)
			);

			this.set("classes", new AlcMBase.BaseCollection());
			this.get("classes").setCreateFunction(
				_.bind(function (id) {
					return new AlcMClass({id: id, user: this});
				}, this)
			);
			this.get("classes").comparator = "start_date";

			this.set("topics", new AlcMBase.BaseCollection());
			this.get("topics").setCreateFunction(
				_.bind(function (id) {
					return new AlcMTopic({id: id, user: this});
				}, this)
			);
			this.get("topics").comparator = "order";

			this.set("astats", new AlcMBase.BaseCollection());
			this.get("astats").setCreateFunction(
				_.bind(function (id) {
					return new AlcMAstat({id: id, user: this});
				}, this)
			);
			// Streak, acc, power, resil
			var astat_order = [4, 1, 2, 3];
			this.get("astats").comparator = function (a) {
				return _.indexOf(astat_order, a.id);
			};

			if (AlcMQuest) {
				this.set("quests", new AlcMBase.BaseCollection());
				this.get("quests").setCreateFunction(
					_.bind(function (id) {
						return new AlcMQuest({id: id, user: this});
					}, this)
				);
				this.get("quests").comparator = "order";
			}

			this.set("trials", new AlcMTrialColl());
			this.get("trials").setCreateFunction(
				_.bind(function (id) {
					return new AlcMTrial({id: id, user: this});
				}, this)
			);
			this.get("trials").watchUser(this);
			// Need to call setLoadParams too, but the ID has to be set before that
			// can happen. If it is set, may as well do it now.
			if (this.get("id") > 0) {
				this.set("user_id", this.get("id")); // RR
				this.get("trials").setLoadParams({
					user_id: this.get("id"),
				});
			}

			if (AlcMLogEntry) {
				this.set("logs", new AlcMBase.BaseCollection());
				this.get("logs").setCreateFunction(
					_.bind(function (id) {
						return new AlcMLogEntry({id: id, user: this});
					}, this)
				);
				this.get("logs").comparator = function (a) {
					return -parseInt(a.id, 10);
				};
			}
		},

		loadUser: function (callback) {
			AlcMBase.ajax.run(
				"load_user",
				{
					user_id: this.id,
					is_me: this.get("is_me") ? 1 : 0,
				},
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}
					this.unpack(data.response.user);
					callback(ok, {});
				}, this)
			);
		},

		requestQuestsLoad: function (callback, context) {
			this.quests_loader.requestLoad(callback, context);
		},

		loadQuests: function (callback) {
			AlcMBase.ajax.run(
				"load_quests",
				{
					user_id: this.id,
				},
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}
					this.get("quests").reset();
					this.get("quests").unpackAll(data.response.quests, "quest_id");
					callback(ok, {});
				}, this)
			);
		},

		// Only used as an admin backdoor at the moment
		loadClass: function (class_id, callback, context) {
			callback = LoadUtils.makeCallback(callback, context);
			AlcMBase.ajax.run(
				"load_class",
				{
					user_id: this.id,
					class_id: class_id,
				},
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}
					this.get("classes").unpackAll([data.response["class"]], "class_id");
					callback(ok, {});
				}, this)
			);
		},

		loadProblemInClass: function (problem_id, class_id, callback, context) {
			callback = LoadUtils.makeCallback(callback, context);
			this.resetDisplayedSolution();
			this.set("displayed_solution_pending", true);
			AlcMBase.ajax.run(
				"load_problem_in_class",
				{
					user_id: this.id,
					class_id: class_id,
					problem_id: problem_id,
				},
				_.bind(function (ok, data) {
					this.set("displayed_solution_pending", false);
					if (!ok) {
						this.set("displayed_solution_error", data.error_code);
						return callback(ok, data);
					}
					this.unpack(data.response);
					callback(ok, {});
				}, this)
			);
		},

		setSubjectOrder: function (subject_order) {
			if (!subject_order) {
				return;
			}
			subject_order = subject_order.map(function (x) {
				return parseInt(x);
			});
			this.get("subjects").comparator = function (a) {
				return _.indexOf(subject_order, parseInt(a.id));
			};
			this.get("subjects").sort();
		},

		pollServerForUpdates: function (new_value) {
			var self = this;
			function doPoll() {
				AlcMBase.ajax.run(
					"update_user",
					{user_id: self.id},
					function (ok, data) {
						if (!ok) {
							if (
								data.error_code === "E_SESSION_ENDED" ||
								data.error_code === "E_UNREGISTERED"
							) {
								clearInterval(self.poll_interval);
							} else {
								console.log("WARNING: update_user polling failed!", data);
							}
						} else {
							self.unpack(data.response.user);
						}
					}
				);
			}

			if (!!this.poll_interval === !!new_value) {
				// No change needed
				return;
			} else if (!new_value) {
				clearInterval(this.poll_interval);
				delete this.poll_interval;
			} else if (new_value) {
				this.poll_interval = setInterval(doPoll, this.update_interval_ms);
			}
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);

			// Topics must be unpacked first. The other collections have their own
			// topics collections with order comparators, which will do the wrong
			// thing if topic order attributes aren't set yet.
			this.get("topics").unpackAll(data.topics, "topic_id");
			this.get("subjects").unpackAll(data.subjects, "subject_id");
			this.get("classes").unpackAll(data.classes, "class_id");
			this.get("astats").unpackAll(data.astats, "astat_id");
			this.get("trials").unpackAll(data.trials, "trial_id");
			this.get("settings").unpack(data.settings);
			this.get("current_problem").unpack(data.current_problem);

			if (data.displayed_solution) {
				var displayed_solution = new AlcMTrial({id: -1, user: this});
				displayed_solution.unpack(data.displayed_solution);
				this.set("displayed_solution", displayed_solution);
			}

			if (AlcMQuest && data.quests) {
				this.get("quests").unpackAll(data.quests, "quest_id");
				this.get("quests").trigger("quests_loaded");
			}

			if (AlcMLogEntry && data.logs) {
				this.get("logs").unpackAll(data.logs, "log_id");
				this.get("logs").trigger("logs_loaded");
			}

			// Detect focus advancing by inspecting the log entries.
			// Also need to remember original focus, since we trigger the
			// event after unpacking the new focus.
			var orig_focus_topic = this.get("focus_topic");
			var orig_focus_parent = this.get("focus_parent");
			var has_advanced_focus = this.hasAdvancedFocusLogEntry(data.logs);

			this.get("problem_stats").unpack(data);
			if (data.focus) {
				this.unpackFocus(data.focus);
			}

			// Trigger the advance event now, if applicable.
			if (has_advanced_focus) {
				this.trigger("advanced_focus", orig_focus_topic, orig_focus_parent);
			}

			// Now that the ID should have been set, setLoadParams on the trial
			// collection.
			if (this.get("id") > 0) {
				this.get("trials").setLoadParams({
					user_id: this.get("id"),
				});
			}

			this.markAsLoaded(true);
		},

		hasAdvancedFocusLogEntry: function (logs) {
			if (!this.get("focus_topic") || !logs) {
				return;
			}
			return _.any(logs, function (log_data) {
				return (
					log_data.just_processed &&
					(log_data.type === "focus_changed" || log_data.type === "class_nag")
				);
			});
		},

		// Helper for unpack.
		unpackFocus: function (focus_data) {
			var models = this.getFocusAsModels(focus_data);

			// Invalid parent can happen due to admin backdooring into classes.
			if (!models || !models[1]) {
				// See defaults in AlcUserFocus
				this.changeFocus({
					parent_type: "subject",
					parent_id: 193,
					topic_id: 346,
					recurse: false,
				});
			} else {
				this.set({
					focus_topic: models[0],
					focus_parent: models[1],
				});
			}
		},

		isAtLeastFriend: function () {
			return (
				this.get("master").get("is_admin") ||
				this.get("is_me") ||
				this.get("is_friend")
			);
		},

		canSeeProfile: function () {
			return !this.get("is_private") && !this.get("is_uninitialized");
		},

		useFullTutorial: function () {
			return this.get("problem_stats").get("total") <= 0;
		},

		getUrlId: function () {
			return this.get("is_me") ? "me" : this.id;
		},

		// Return a Subject model that most closely matches what the user is doing
		// now, or falsy if somehow one could not be found.
		// Pass a Problem or Trial model in to try to extract a subject from that
		// in the event the focus check fails. Defaults to current_problem.
		getCurrentSubject: function (problem) {
			var focus_parent = this.get("focus_parent");
			// Always use the focus parent if it exists, either the subject or the
			// subject attached to the class
			if (focus_parent && focus_parent.model_type === "subject") {
				return focus_parent;
			} else if (
				focus_parent &&
				focus_parent.model_type === "class" &&
				focus_parent.get("subject")
			) {
				return focus_parent.get("subject");
			}

			// Otherwise, grab the hardest subject model applicable to the problem.

			problem = problem || this.get("current_problem");
			// ... assuming there is a problem ...
			if (!problem) {
				return null;
			}

			var level_data = problem.get("level_data");
			// ... and that it has level data.
			if (!level_data || !level_data.length) {
				return null;
			}

			// User subject collection is easiest to hardest. Filter that collection
			// for applicable subjects...
			var subject_ids = _.pluck(level_data, "subject_id");
			subject_ids = _.map(subject_ids, function (x) {
				return parseInt(x, 10);
			});
			var subjects = this.get("subjects").filter(function (subject) {
				return _.contains(subject_ids, subject.id);
			});
			// ... then extract the last (hardest) one.
			return subjects.length ? subjects[subjects.length - 1] : null;
		},

		getActiveQuestsCollection: function () {
			var coll = new Backbone.Collection(
				this.get("quests").where({is_assigned: true})
			);
			coll.comparator = "order";
			coll.sort();
			return coll;
		},

		// Returns [topic model, parent model] given an object with parent_id,
		// parent_type, and topic_id values. Uses the usual format of focus_topic
		// and focus_parent.
		getFocusAsModels: function (focus_data) {
			if (!focus_data) {
				return null;
			}

			var topic_model;
			var parent_model;
			var parent_id = parseInt(focus_data.parent_id, 10);
			var topic_id = parseInt(focus_data.topic_id, 10);

			if (focus_data.parent_type === "class") {
				parent_model = this.get("classes").get(parent_id);
			} else if (parent_id) {
				parent_model = this.get("subjects").get(parent_id);
			} else {
				parent_model = this;
			}

			// If the log entry is dumb or it's for an expired class, stop.
			if (!parent_model) {
				return null;
			}

			if (topic_id) {
				topic_model = this.get("topics").get(topic_id);
			} else {
				topic_model = parent_model;
			}

			return [topic_model, parent_model];
		},

		// Returns an object with parent_id, parent_type, and topic_id values.
		// topic_id is 0 if the focus is an All topics focus. parent_id is 0
		// if the focus is All topics in all subjects. parent_type is either
		// 'subject' or 'class', with 'subject' used for All topics values.
		// Parameters are optional; uses current focus if not given.
		getFocusAsObject: function (focus_topic, focus_parent) {
			var result = {
				parent_id: 0,
				parent_type: "subject",
				topic_id: 0,
			};
			focus_topic = focus_topic || this.get("focus_topic");
			focus_parent = focus_parent || this.get("focus_parent");

			if (focus_topic && focus_topic.model_type === "topic") {
				result.topic_id = focus_topic.id;
			} // Else, leave topic_id as 0

			if (focus_parent && focus_parent.model_type !== "user") {
				result.parent_type = focus_parent.model_type;
				result.parent_id = focus_parent.id;
			} // Else, leave parent_id as 0

			return result;
		},

		// Compare two focus objects.
		// f1 and f2 are objects with return format of getFocusAsObject.
		// Done this way due to number/string comparison issues.
		isFocusEqual: function (f1, f2) {
			return (
				parseInt(f1.topic_id) === parseInt(f2.topic_id) &&
				parseInt(f1.parent_id) === parseInt(f2.parent_id) &&
				f1.parent_type === f2.parent_type
			);
		},

		// new_focus_data is a return from getFocusAsObject.
		// Returns whether the request was accepted; repeated requests are filtered
		// if the allow_filter option is true.
		changeFocus: function (new_focus_data, callback, options) {
			options = options || {};
			callback = LoadUtils.makeCallback(callback, options.context);

			// Ignore repeated requests
			if (this.changing_focus && options.allow_filter) {
				// Don't call the callback.
				return false;
			}

			// Check if this is actually a change. Don't make pointless server calls.
			if (
				!this.get("is_tutorial_active") &&
				!this.changing_focus &&
				this.isFocusEqual(this.getFocusAsObject(), new_focus_data)
			) {
				setTimeout(function () {
					callback(true, new_focus_data);
				}, 0);
				return false;
			}

			new_focus_data = _.extend({user_id: this.id}, new_focus_data);
			if (this.get("is_tutorial_active")) {
				new_focus_data.tutorial = 1;
			}

			// Remember old data so we can switch back on an error.
			var original_focus_data = this.getFocusAsObject();
			var original_problem = this.get("current_problem");
			// The newly made problem. Gets set as the current_problem before
			// change_focus finishes so views update appropriately.
			var new_problem = new AlcMProblem({user: this});

			// Bit crafty here... we're about to change the user's current_problem
			// model, which will cause a bunch of views to ask the new one to load. The
			// change_focus call below is already doing that loading, so the problem
			// needs to not make a server call of its own.
			// Solution: inject into the newly created problem this new loader, which uses
			// the change_focus call as the handler. In effect, that means all
			// requests for the problem to load will wait on this call instead of
			// starting a new one.
			var problem_focus_loader = new LoadUtils.LoadManager({
				loadHandler: function (changeFocusCallback) {
					AlcMBase.ajax.run(
						"change_focus",
						new_focus_data,
						_.bind(function (ok, data) {
							this.resetDisplayedSolution();
							if (!ok) {
								// Revert all changes.
								this.set("current_problem", original_problem);
								this.unpackFocus(original_focus_data);
								return changeFocusCallback(ok, data);
							}
							this.unpack(data.response.user);
							changeFocusCallback(ok, new_focus_data);
						}, this),
						{no_filter: !options.allow_filter}
					);
				},
				context: this,
			});
			new_problem.setLoader(problem_focus_loader);

			// Lots of events fire from this set call; the worst they'll do is
			// beat us to requesting that the problem load. Same behavior either way.
			this.set("is_tutorial_active", 0);
			this.set("current_problem", new_problem);
			this.trigger("focus_set");
			if (new_focus_data.recurse !== false) {
				this.unpackFocus(new_focus_data);
			}

			this.changing_focus = true;
			problem_focus_loader.requestLoad(function (ok, data) {
				this.changing_focus = false;
				callback(ok, data);
			}, this);

			return true;
		},

		findTrialByProblemId: function (problem_id, callback, context) {
			callback = LoadUtils.makeCallback(callback, context);

			// First, check if we already have a trial with the given problem ID
			var loaded_ids = this.get("trials").pluck("problem_id");
			var match_ind = _.indexOf(loaded_ids, problem_id);
			var match;
			if (match_ind >= 0) {
				match = this.get("trials").at(match_ind);
				setTimeout(function () {
					callback(true, match);
				}, 0);
				return;
			}

			// Nope; time to go to the server.
			// Sanity check the argument before that.
			if (!_.isFinite(problem_id)) {
				setTimeout(function () {
					callback(false, {
						error_code: "E_INVALID_INPUT",
						error_msg: 'Invalid problem ID "' + problem_id + '".',
					});
				}, 0);
				return;
			}

			AlcMBase.ajax.run(
				"find_user_problem",
				{
					user_id: this.id,
					problem_id: problem_id,
				},
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}

					var trial = new AlcMTrial({user: this});
					trial.unpack(data.response.trial);
					this.trigger("new_trial", trial);
					callback(true, trial);
				}, this)
			);
		},

		// Reset all state related to displayed_solution.
		resetDisplayedSolution: function () {
			this.set("displayed_solution", null);
			this.set("displayed_solution_pending", false);
			this.set("displayed_solution_error", null);
		},

		// next_problem_data is the data for the next problem. Optional, but
		// can be provided to save an AJAX call if it's available.
		finishCurrentProblem: function (next_problem_data, callback, context) {
			// All trial collections are out of date as of now.
			this.trigger("new_trial", this.get("current_problem").get("trial"));

			// Switch to the next problem.
			var next_problem = new AlcMProblem({user: this});
			next_problem.unpack(next_problem_data);
			this.set("current_problem", next_problem);
			this.resetDisplayedSolution();
			// This may or may not do AJAX depending on whether next_problem_data
			// was provided or not.
			next_problem.requestLoad(callback, context);
		},

		startReset: function (confirm_response, callback, context) {
			callback = LoadUtils.makeCallback(callback, context);

			AlcMBase.ajax.run(
				"reset_user",
				{
					user_id: this.id,
					confirm_response: confirm_response,
				},
				callback
			);
		},

		fetchFriends: function (obj) {
			return (
				AoPS.Community &&
				AoPS.Community.Models.User.prototype.fetchFriends.apply(this, [obj])
			);
		},

		wasFriendAddedDuringThisPageLoad: function () {
			return false;
		},
	});
})();
